// extracted by mini-css-extract-plugin
module.exports = {"avatar":"dialog-online_avatar_38-0V","ManageModel":"dialog-online_ManageModel_2EGnV"};